import { QueryClientConfig } from "@tanstack/react-query";

// API error side effects (401 reload, Dashboard's 409 org-switch redirect) are
// handled in the request wrappers via `handleApiError` from `util/api`, not in a
// QueryCache `onError`. Doing it in the request path lets the side effect run
// before the query transitions to an error state, so no error UI flashes before
// the page reloads/redirects.
export const getQueryClientDefaultOptions = (): QueryClientConfig => {
  return {
    defaultOptions: {
      queries: {
        retry: false,
      },
    },
  };
};
